
import axios from 'axios'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import VueUploadComponent from 'vue-upload-component'
export default {
components: {Toast, Popup, XButton},
comments: {
FileUpload: VueUploadComponent
},
directives: {TransferDom},
data(){
return{
showPop: false,
educationList1: [{
label: '请选择',
value: ''
},{
label: '985博士',
value: '985博士',
},{
label: '211博士',
value: '211博士',
},{
label: '本一博士',
value: '本一博士',
},{
label: '本二博士',
value: '本二博士',
},{
label: '985硕士',
value: '985硕士',
},{
label: '211硕士',
value: '211硕士',
},{
label: '本一硕士',
value: '本一硕士',
},{
label: '本二硕士',
value: '本二硕士',
},{
label: '985本科',
value: '985本科',
},{
label: '211本科',
value: '211本科',
},{
label: '本一',
value: '本一',
},{
label: '本二',
value: '本二',
},{
label: '专升本',
value: '专升本',
},{
label: '本科以下',
value: '本科以下'
}],

placeList: [{
label: '请选择',
value: ''
},{
label: '常州',
value: '常州'
},{
label: '南通',
value: '南通'
},{
label: '淮安',
value: '淮安'
},{
label: '中天西太湖度假酒店',
value: '中天西太湖度假酒店'
},{
label: '南通中天钢铁大酒店',
value: '南通中天钢铁大酒店'
},{
label: '常州经开区酒店',
value: '常州经开区酒店'
},{
label: '常州皓鸣科技',
value: '常州皓鸣科技'
},{
label: '不限',
value: '不限'
}],
educationList2: [{
label: '请选择',
value: ''
},{
label: '本科',
value: '本科'
},{
label: '硕士',
value: '硕士'
},{
label: '博士',
value: '博士'
},{
label: '本科以下',
value: '本科以下'
}],
name: '',
sex: '',
education: '',
major: '',
school: '', // 学校 - 国内
abroadSchool: '', // 学校 - 国外
workplace: '',
post: '', // 意向岗位类别
email: '',
phone: '',
picture: '',// 简历图片

height: '',
weight: '',
nation: '',
native: '',
englishLevel: '',
englishLevelList: [
{
value: '',
label: '请选择'
},
{
value: 0,
label: '通过CET4'
},
{
value: 1,
label: '通过CET6'
},
{
value: 2,
label: '未通过'
}
],
political: '',
politicalList: [
{
value: '',
label: '请选择'
},
{
value: 0,
label: '群众'
},
{
value: 1,
label: '团员'
},
{
value: 2,
label: '党员'
},
{
value: 3,
label: '入党积极分子'
},
],
fulltime: '',
fulltimeList: [
{
value: '',
label: '请选择'
},
{
value: 0,
label: '是'
},
{
value: 1,
label: '否'
}
],










file: '', // 通过DOM取文件数据
formData: {},
ispictureexit: true, // 是否已上传图片，已有图片则隐藏div
fileTypeImage: '', // 默认文件上传格式为image/jpeg
filename: '',

basePath: 'http://student.hmifo.com/admin/', // 正式服


province: '',
provinceList: [],
city: '',
cityList: [],
schoolChoose: '',
schoolList:[],
postOptions: [
{
value: '',
label: '请选择'
},
{
value: '管理类',
label: '管理类'
},
{
value: '教育类',
label: '教育类'
},
{
value: '信息类',
label: '信息类'
},
{
value: '技术类',
label: '技术类'
},{
label: '酒店类/行政类',
value: '酒店类/行政类'
},{
label: '酒店类/接待客房类',
value: '酒店类/接待客房类'
},{
label: '酒店类/销售采购类',
value: '酒店类/销售采购类'
},{
label: '酒店类/后厨类',
value: '酒店类/后厨类'
}
],
schoolFrom: '0', // 0 - 国内  1 - 国外
recommendType: '0', // 0 - 是  1 - 否
inRecommend: '',
findSchool: true
}
},
methods:{
chooseSchool(){
this.schoolChoose = ''
this.findSchool = true
this.showPop = true

this.getSchoolList(this.province,0)
},
getSchoolList(a,type){
var param = new URLSearchParams()
if (type === 0){ // 初始加载 传值空
param.append('province', '')
param.append('location', '')
param.append('name', '')
} else if (type === 1) { // 选择省级
param.append('province', a)
param.append('location', '')
param.append('name', '')
} else { // 选择省、区级
param.append('province', this.province)
param.append('location', a)
param.append('name', '')
}
axios.post(this.basePath + 'resume/schoolSift', param).then(res => {
var arrayList = []
if (res.data.code === 200){
for (var i = 0; i < res.data.data.length;i++){
if (type === 0){ // 初始加载 传值空 省级赋值
var province = {"label": res.data.data[i].province, "value": res.data.data[i].province}
arrayList.push(province)
this.provinceList = arrayList
} else if (type === 1) { // 区级赋值
var city = {"label": res.data.data[i].location, "value": res.data.data[i].location}
arrayList.push(city)
this.cityList = arrayList
} else { // 校级赋值
var school = {"label": res.data.data[i].name, "value": res.data.data[i].name}
arrayList.push(school)
this.schoolList = arrayList
}
}
} else {
console.log('error')


}
})
},
submitSchool(){
var school = this.schoolChoose
this.school = school

this.showPop = false
this.province = ''
this.city = ''
this.schoolChoose = ''
},
cancelSchool(){

this.showPop = false
this.province = ''
this.city = ''
this.schoolChoose = ''
},
isMoblie(value){ // 手机号校验
return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value);
},
isEmail(value){ // 邮箱校验
return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)
},
submitInfo(){
if (this.name === '') {this.$vux.toast.text('请填写姓名！'); return}
if (this.sex === '') {this.$vux.toast.text('请选择性别！'); return}
if (this.education === '') {this.$vux.toast.text('请选择学历！'); return}
if (this.major === '') {this.$vux.toast.text('请选择所学专业！'); return}
if (this.schoolFrom == '0') {
if (this.school === '') {this.$vux.toast.text('请选择国内院校名称！'); return}
} else {
if (this.abroadSchool === '') {this.$vux.toast.text('请填写国外院校名称！'); return}
}
if (this.workplace === '') {this.$vux.toast.text('请选择意向工作地！'); return}
if (this.post === '') {this.$vux.toast.text('请选择意向岗位类别！'); return}
if (this.email === '') {this.$vux.toast.text('请填写邮箱！'); return}
if (this.phone === '') {this.$vux.toast.text('请填写联系方式！'); return}
if (this.picture === '') {this.$vux.toast.text('请上传简历！'); return}
if (!this.isMoblie(this.phone)) {this.$vux.toast.text('手机号码格式错误!'); return}
if (!this.isEmail(this.email)) {this.$vux.toast.text('邮箱格式错误!'); return}

if (this.height === '') {this.$vux.toast.text('请填写身高！'); return}
if (this.weight === '') {this.$vux.toast.text('请填写体重！'); return}
if (this.nation === '') {this.$vux.toast.text('请填写民族！'); return}
if (this.native === '') {this.$vux.toast.text('请填写籍贯！'); return}
if (this.englishLevel === '') {this.$vux.toast.text('请选择英语水平！'); return}
if (this.political === '') {this.$vux.toast.text('请选择政治面貌！'); return}
if (this.fulltime === '') {this.$vux.toast.text('请选择是否全日制统招本科！'); return}
if (this.recommendType === '0' && this.inRecommend === '') {this.$vux.toast.text('请输入内部推荐员工工号！'); return}

let param = new URLSearchParams();
param.append('name', this.name);
param.append('sex', this.sex);
param.append('education', this.education);
param.append('major', this.major);
if (this.schoolFrom == '0') {
param.append('school', this.school);
} else {
param.append('abroadSchool', this.abroadSchool);
}
param.append('intendedPlace', this.workplace);
param.append('intendedJobCategory', this.post);
param.append('email', this.email);
param.append('mobile', this.phone);
param.append('resume', this.picture);

let height = this.height + 'cm'
let weight = this.weight + 'kg'
param.append('height', height);
param.append('weight', weight);
param.append('ethnic', this.nation);
param.append('origin', this.native);
param.append('english', this.englishLevel);
param.append('political', this.political);
param.append('fullGraduate', this.fulltime);
param.append('recommendType', this.recommendType);
if (this.recommendType === '0') {
param.append('inRecommend', this.inRecommend);
}
axios.post(this.basePath + 'resume/resumeApply',param).then(res => {
if (res.data.code === 200) {
this.$vux.toast.text('提交成功！')

this.name = ''
this.sex = ''
this.education = ''
this.major = ''
this.school = ''
this.abroadSchool = ''
this.workplace = ''
this.post = ''
this.email = ''
this.phone = ''
this.picture = ''
this.ispictureexit = true

this.height = ''
this.weight = ''
this.nation = ''
this.native = ''
this.englishLevel = ''
this.political = ''
this.fulltime = ''
this.inRecommend = ''
} else {
this.$vux.toast.text(res.msg)
}

})
},
handleFileChange(){
let inputDOM = this.$refs.pictureRef
this.file = inputDOM.files[0];
this.formData = new FormData();
this.formData.append("file", this.file); 
console.log(this.file.name)
if (this.file.type === 'image/jpeg') {
this.fileTypeImage = 'image/jpeg'
} else {
this.fileTypeImage = ''
this.filename = this.file.name
}

axios.post(this.basePath + 'resume/storage/upload', this.formData).then((r) => {
if (r.data.code === 200) {
this.ispictureexit = false
this.picture = r.data.data.pictureName
this.$vux.toast.text('文件上传成功！')
} else {
this.$vux.toast.text('文件上传失败，请重试！')
}
}).catch((error) => {
console.log(error);
this.$vux.toast.text('提交失败!')
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/ResumeDelivery.vue